module.exports = __webpack_public_path__ + "img/img11.d3e9d2ab.png";